import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, withLatestFrom } from 'rxjs/operators';

import { addDevice } from './device.actions';
import { addPlayground, updateCurrentDevicePlayground, updatePlayground } from './playground.actions';
import { defaultPlayground, Playground } from './playground.model';

import { AppState } from './index';

@Injectable()
export class PlaygroundEffects {
  private actions$ = inject(Actions);
  private store$ = inject<Store<AppState>>(Store);

  updateCurrentDevicePlayground$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCurrentDevicePlayground),
      withLatestFrom(this.store$),
      map(([action, state]) =>
        updatePlayground({
          update: {
            changes: action.changes,
            id: state.devices.selectedDeviceSerialNumber,
          },
        }),
      ),
    ),
  );

  addPlaygroundOnAddDevice = createEffect(() =>
    this.actions$.pipe(
      ofType(addDevice),
      withLatestFrom(this.store$),
      map(([action, state]) => {
        const device = action.device;
        const playground: Playground = state.playgrounds.entities[device.serialNumber];
        if (!playground) {
          return { ...defaultPlayground, deviceSerialNumber: device.serialNumber } as Playground;
        }
      }),
      filter((playground) => playground !== undefined),
      map((playground) => addPlayground({ playground })),
    ),
  );
}
